module.exports = __webpack_public_path__ + "media/images/flags/4x3/tcd-180f416f04d69f203dd0d921bb802ed8.svg";